import { animationTransition } from '@shared/utils/animationTransition';
import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, Flex, styled, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledItemRow = styled(Flex)``;
const itemRowStyles: StyleSystemProps = {
  width: '100%',
  alignItems: 'center',
};

export const StyledItemTextWrapper = styled(Flex)``;
const itemTextWrapperStyles: StyleSystemProps = {
  justifyContent: 'center',
  width: '100%',
  flexDirection: 'column',
  color: 'mono10',
  transition: animationTransition('color'),
  _groupHover: {
    color: 'linkHover',
  },
};

export const StyledCheckboxWrapper = styled(Flex)``;
const checkboxWrapperStyles: StyleSystemProps = {
  justifyContent: 'center',
  alignItems: 'center',
  flex: `0 0 ${pxToRem(48)}`,
  marginRight: 5,
};

export const StyledProductImage = styled(Flex)``;
const productImageStyles = (isCompleted: boolean): StyleSystemProps => ({
  borderRadius: pxToRem(8),
  backgroundColor: 'mono1',
  borderWidth: pxToRem(2),
  borderColor: 'mono3',
  borderStyle: isCompleted ? 'solid' : 'dashed',
  flex: `0 0 ${pxToRem(48)}`,
  height: pxToRem(48),
  marginRight: 5,
  justifyContent: 'center',
  alignItems: 'center',
  transition: animationTransition('border-color', 'background-color'),
  position: 'relative',
  overflow: 'hidden',
  _groupActive: {
    backgroundColor: 'mono3',
    borderColor: 'mono7',
  },
  _groupHover: {
    backgroundColor: 'mono2',
    borderColor: 'mono5',
    _after: {
      backgroundSize: '110%',
      opacity: 0.5,
    },
  },
  _after: {
    transition: animationTransition('background-size', 'opacity'),
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
  },
});

export const StyledAddProductWrapper = styled(Box)``;
const addProductWrapperStyles: StyleSystemProps = {
  zIndex: 1,
  height: 6,
  width: 6,
  transition: animationTransition('opacity'),
  _groupHover: {
    opacity: 0.4,
  },
  _groupActive: {
    opacity: 0.6,
  },
};

export const StyledTitle = styled(TextV2)``;
const titleStyles: StyleSystemProps = {
  color: 'mono14',
  transition: animationTransition('color'),
  _groupHover: {
    color: 'linkHover',
  },
};

export const styles = {
  itemRow: itemRowStyles,
  itemTextWrapper: itemTextWrapperStyles,
  checkboxWrapper: checkboxWrapperStyles,
  productImage: productImageStyles,
  addProductWrapper: addProductWrapperStyles,
  title: titleStyles,
};
